import { render, staticRenderFns } from "./saleOrderDetail.vue?vue&type=template&id=5e5ab9a8&scoped=true"
import script from "./saleOrderDetail.vue?vue&type=script&lang=js"
export * from "./saleOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./saleOrderDetail.vue?vue&type=style&index=0&id=5e5ab9a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5ab9a8",
  null
  
)

export default component.exports